import {
    SelectList,
    SelectSeperator,
    SelectTitle,
    SelectZeroResultIcon,
    SelectZeroResults,
} from "./Styled";
import React from "react";
import {SelectListHandler} from "./SelectListHandler";
import {MULTI_SELECT, SINGLE_SELECT} from "../utils";
import CheckBox from "../../CheckBox";
import {BasicItem, SelectMenuInterface} from "../types";

const SelectMenu = function <T extends BasicItem>({
    items,
    getItemProps,
    highlightedIndex,
    itemToString,
    type,
    maxSelectedLength,
    // selectedItems,
    userSelectedItems,
    withOptGroup, // Need to check it.
    // menuLegend,
    fieldName,
    withSearch,
}: SelectMenuInterface<T>): JSX.Element {
    const multiSelectIds: number[] = [];
    if (type === MULTI_SELECT) {
        userSelectedItems.reduce((finalList, item) => {
            item && finalList.push(item.id);
            return finalList;
        }, multiSelectIds);
    }

    return (
        <SelectList type={type}>
            {
                items.length === 0 ? (
                    <SelectZeroResults>
                        <SelectZeroResultIcon />
                        <p>No Results Found</p>
                    </SelectZeroResults>
                ) : !withSearch && type === SINGLE_SELECT ? (
                    <SelectTitle withSearch={withSearch}>SELECT ONE</SelectTitle>
                ) : (
                    ""
                )
                // <SelectTitle>
                //     {menuLegend
                //         ? menuLegend
                //         : type === MULTI_SELECT
                //             ? "Choose Options"
                //             : "SELECT ONE"}
                // </SelectTitle>
            }
            {items.map((item, index) => {
                let isSelected = false,
                    isMaxLimitReached = false;
                if (type === MULTI_SELECT) {
                    isSelected = multiSelectIds.includes(item.id);
                    isMaxLimitReached = multiSelectIds.length === maxSelectedLength;
                }
                return (
                    <React.Fragment key={`${item.id}${index}`}>
                        <SelectListHandler
                            item={item}
                            getItemProps={getItemProps}
                            highlightedIndex={highlightedIndex}
                            index={index}
                            isSelected={isSelected}
                            withOptGroup={withOptGroup}
                            isDisabled={
                                (isMaxLimitReached && !isSelected) ||
                                (typeof item.disabled !== "undefined" && item.disabled == true)
                            }
                        >
                            {type === MULTI_SELECT && (
                                <CheckBox
                                    id={`${fieldName}_${item.id}`}
                                    isChecked={isSelected}
                                    onChange={() => null}
                                    isDisabled={isMaxLimitReached && !isSelected}
                                    inputRFF={{
                                        onBlur: () => null,
                                        onFocus: () => null,
                                        onChange: () => null,
                                        name: fieldName,
                                        value: isSelected,
                                        checked: isSelected,
                                    }}
                                />
                            )}

                            {itemToString ? itemToString(item) : ""}
                        </SelectListHandler>
                        <SelectSeperator />
                    </React.Fragment>
                );
            })}
        </SelectList>
    );
};
export default SelectMenu;
